import React, { useRef } from 'react';
import { BiDotsVerticalRounded, BiFilterAlt } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Icon, IconButton,
  Popover, PopoverArrow, PopoverBody, PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal
} from '@chakra-ui/react';

import SearchColumnCheckbox from '../SearchColumnCheckbox';

const SearchColumnToggle = ({ variant, searchBlueprint, dataAnalyticsId }) => {
  const focusRef = useRef();
  const columns = useSelector(searchBlueprint.selectColumns);
  const hiddenColumnIds = useSelector(searchBlueprint.selectHiddenColumnIds);
  const dispatch = useDispatch();

  const toggleColumn = columnId => checked => {
    dispatch(searchBlueprint.toggleColumn(columnId, checked));
  };

  return (
    <Popover
      initialFocusRef={focusRef}
      placement="left"
    >
      <PopoverTrigger>
        <Box>
          <IconButton
            aria-label="Toggle Columns"
            data-analytics-id={dataAnalyticsId}
            dusk="search-table-column-selector-icon"
            icon={<Icon as={BiDotsVerticalRounded} h={7} w={7} />}
            variant={variant}
          />
        </Box>
      </PopoverTrigger>
      <Portal placement="left">
        <PopoverContent p={4} width="100%">
          <PopoverArrow />
          <PopoverHeader border="0" mb={4} p={0} textStyle="bodyLg500">
            Columns:
          </PopoverHeader>
          <PopoverCloseButton />
          <PopoverBody p={0}>
            <input ref={focusRef} style={{ display: 'none' }} />
            {columns.map((column, index) => {
              const id = column.id || column.accessor;

              return (
                <SearchColumnCheckbox
                  checked={!hiddenColumnIds.includes(id)}
                  key={id}
                  name={column.name || column.id || column.accessor}
                  onChange={toggleColumn(id)}
                />
              );
            })}
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default SearchColumnToggle;
